import { api_url, logout } from "./api-endpoint";

import axios from "axios";

const api = axios.create({
  baseURL: api_url,
  timeout: 10000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      logout();
      throw new Error("Session expired. Login again.");
    }
    return Promise.reject(error);
  },
);

export default api;
